var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmericanExpress = function SvgAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    x: 0.5,
    y: 3.5,
    fill: "#1F72CD",
    stroke: "#D9D9D9",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m4.325 8.972-2.238 5.265h2.679l.332-.84h.759l.332.84h2.948v-.64l.263.64h1.525l.263-.654v.654h6.132l.745-.818.699.818 3.15.007-2.245-2.625 2.244-2.647h-3.1l-.726.802-.677-.802h-6.67l-.573 1.359-.586-1.36H6.908v.62l-.298-.62zm9.156.747h3.522l1.076 1.237 1.112-1.237h1.077l-1.636 1.9 1.636 1.876h-1.126l-1.077-1.251-1.117 1.251h-3.467zm.87 1.472v-.69h2.197l.959 1.103-1.001 1.11H14.35v-.754h1.92v-.769zM4.843 9.72h1.305l1.485 3.57V9.72h1.43l1.146 2.56 1.057-2.56h1.423v3.779h-.866l-.007-2.961-1.263 2.96H9.78l-1.27-2.96v2.96H6.728l-.338-.846H4.565l-.337.846h-.954zm.034 2.149.601-1.51.6 1.51z",
    clipRule: "evenodd"
  })));
};
export default SvgAmericanExpress;